export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.workbench.link': '工作台',
  'pages.workbench.alertMessage': '欢迎来到工作台',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.zy-crm.lead.title': '线索列表',
  'pages.zy-crm.customer.title': '客户列表',
  'pages.zy-crm.contact.title': '联系人列表',
  'pages.zy-crm.contact.detailTitle': '联系人详情',
  'pages.zy-crm.common.confirmDelete': '确认删除',
  'pages.zy-crm.common.confirmDeleteContent': '删除后不可恢复，请谨慎操作。',
  'pages.zy-crm.common.deleteSuccess': '删除成功',
  'pages.zy-crm.common.updateSuccess': '更新成功',
  'pages.zy-crm.common.createSuccess': '创建成功',
  'pages.zy-crm.common.operation': '操作',
  'pages.zy-crm.common.detail': '详情',
  'pages.zy-crm.common.edit': '编辑',
  'pages.zy-crm.common.delete': '删除',
  'pages.zy-crm.common.refresh': '刷新',
  'pages.zy-crm.common.create': '新建',
  'pages.zy-crm.common.detailLoadFailed': '详情加载失败',
  'pages.zy-crm.common.missingUuid': '缺少 uuid 参数',
  'pages.zy-crm.common.noDetailData': '未找到详情数据',
  'pages.zy-crm.common.id': 'ID',
  'pages.zy-crm.common.relatedData': '关联数据',
  'pages.zy-crm.common.relatedDataTodo': '关联数据可按业务接口补充',
  'pages.zy-crm.common.required': '必填项',
  'pages.zy-crm.common.yes': '是',
  'pages.zy-crm.common.no': '否',
  'pages.zy-crm.opportunityPipelines.title': '商机管道配置',
  'pages.zy-crm.opportunityStages.title': '商机阶段配置',
  'pages.zy-crm.areas.title': '地区配置',
  'pages.zy-crm.industries.title': '行业配置',
  'pages.zy-crm.productCategories.title': '产品分类配置',
  'pages.zy-crm.sourceChannels.title': '来源渠道配置',
  'pages.zy-crm.customerLevels.title': '客户等级配置',
  'pages.zy-crm.dictionary.column.id': 'ID',
  'pages.zy-crm.dictionary.column.uuid': '标识',
  'pages.zy-crm.dictionary.column.name': '名称',
  'pages.zy-crm.dictionary.column.updateTime': '更新时间',
  'pages.zy-crm.dictionary.confirmDeleteOne': '确认删除该条记录吗？',
  'pages.zy-crm.dictionary.modal.editTitle': '编辑{title}',
  'pages.zy-crm.dictionary.modal.createTitle': '新建{title}',
  'pages.zy-crm.dictionary.validation.nameRequired': '名称不能为空',
  'pages.zy-crm.dictionary.validation.enterName': '请输入名称',
  'pages.zy-crm.dictionary.field.name': '名称',
  'pages.zy-crm.dictionary.field.uuidOptional': '标识（系统生成）',
  'pages.zy-crm.dictionary.field.uuidHint': '由系统自动生成，无需手动填写',
  'pages.zy-crm.dictionaryManagement.field.type': '字典类型',
  'pages.zy-crm.contact.management': '联系人管理',
  'pages.zy-crm.contact.unknownMember': '未知成员',
  'pages.zy-crm.contact.memberLoadFailed': '成员列表加载失败，请稍后重试',
  'pages.zy-crm.contact.memberLoadFailedSubmit':
    '成员列表加载失败，无法提交，请先重试',
  'pages.zy-crm.contact.field.name': '联系人姓名',
  'pages.zy-crm.contact.field.customer': '客户',
  'pages.zy-crm.contact.field.lastContactTime': '最近联系时间',
  'pages.zy-crm.contact.field.lastContactContent': '最近联系内容',
  'pages.zy-crm.contact.field.nextContactTime': '下次联系时间',
  'pages.zy-crm.contact.field.owner': '负责人',
  'pages.zy-crm.contact.field.status': '状态',
  'pages.zy-crm.contact.field.mobile': '手机号',
  'pages.zy-crm.contact.field.telephone': '电话',
  'pages.zy-crm.contact.field.email': '邮箱',
  'pages.zy-crm.contact.field.qq': 'QQ',
  'pages.zy-crm.contact.field.wechat': '微信',
  'pages.zy-crm.contact.field.area': '地区',
  'pages.zy-crm.contact.field.parent': '上级联系人',
  'pages.zy-crm.contact.field.detailAddress': '详细地址',
  'pages.zy-crm.contact.field.remark': '备注',
  'pages.zy-crm.contact.field.post': '职位',
  'pages.zy-crm.contact.field.sex': '性别',
  'pages.zy-crm.contact.field.isPrimaryDecisionMaker': '主要决策人',
  'pages.zy-crm.contact.placeholder.name': '请输入联系人姓名',
  'pages.zy-crm.contact.placeholder.lastContactContent': '请输入最近联系内容',
  'pages.zy-crm.contact.placeholder.lastContactTime': '请选择最近联系时间',
  'pages.zy-crm.contact.placeholder.nextContactTime': '请选择下次联系时间',
  'pages.zy-crm.contact.placeholder.email': '请输入邮箱',
  'pages.zy-crm.contact.placeholder.mobile': '请输入手机号',
  'pages.zy-crm.contact.placeholder.qq': '请输入QQ',
  'pages.zy-crm.contact.placeholder.telephone': '请输入电话',
  'pages.zy-crm.contact.placeholder.wechat': '请输入微信',
  'pages.zy-crm.contact.placeholder.area': '请输入地区编号',
  'pages.zy-crm.contact.placeholder.customer': '请输入客户编号',
  'pages.zy-crm.contact.placeholder.owner': '请选择负责人',
  'pages.zy-crm.contact.placeholder.parent': '请输入上级联系人编号',
  'pages.zy-crm.contact.placeholder.detailAddress': '请输入详细地址',
  'pages.zy-crm.contact.placeholder.remark': '请输入备注',
  'pages.zy-crm.contact.placeholder.isPrimaryDecisionMaker':
    '请选择是否为主要决策人',
  'pages.zy-crm.contact.placeholder.post': '请输入职位',
  'pages.zy-crm.contact.placeholder.sex': '请输入性别编码',
  'pages.zy-crm.contact.section.basic': '基础信息',
  'pages.zy-crm.contact.section.followUp': '跟进信息',
  'pages.zy-crm.contact.section.contact': '联系方式',
  'pages.zy-crm.contact.section.relation': '关联信息',
  'pages.zy-crm.contact.section.remark': '备注或补充',
  'pages.zy-crm.contact.section.other': '其他信息',
  'pages.zy-crm.opportunity.title': '商机列表',
  'pages.zy-crm.opportunity.detailTitle': '商机详情',
  'pages.zy-crm.opportunity.card.manageTitle': '商机管理',
  'pages.zy-crm.opportunity.action.refresh': '刷新',
  'pages.zy-crm.opportunity.action.create': '新建',
  'pages.zy-crm.opportunity.action.detail': '详情',
  'pages.zy-crm.opportunity.action.edit': '编辑',
  'pages.zy-crm.opportunity.action.delete': '删除',
  'pages.zy-crm.opportunity.column.operation': '操作',
  'pages.zy-crm.opportunity.modal.createTitle': '新建',
  'pages.zy-crm.opportunity.modal.editTitle': '编辑',
  'pages.zy-crm.opportunity.modal.deleteTitle': '确认删除',
  'pages.zy-crm.opportunity.modal.deleteContent':
    '删除后不可恢复，请谨慎操作。',
  'pages.zy-crm.opportunity.form.required': '必填项',
  'pages.zy-crm.opportunity.form.placeholder.input': '请输入{label}',
  'pages.zy-crm.opportunity.form.placeholder.select': '请选择{label}',
  'pages.zy-crm.opportunity.form.placeholder.relation': '请输入关联{label}',
  'pages.zy-crm.opportunity.form.bool.yes': '是',
  'pages.zy-crm.opportunity.form.bool.no': '否',
  'pages.zy-crm.opportunity.form.group.basic': '基础信息',
  'pages.zy-crm.opportunity.form.group.followup': '跟进信息',
  'pages.zy-crm.opportunity.form.group.contact': '联系方式',
  'pages.zy-crm.opportunity.form.group.business': '业务信息',
  'pages.zy-crm.opportunity.form.group.relation': '关联信息',
  'pages.zy-crm.opportunity.form.group.detail': '备注或补充',
  'pages.zy-crm.opportunity.form.group.other': '其他信息',
  'pages.zy-crm.opportunity.message.createSuccess': '创建成功',
  'pages.zy-crm.opportunity.message.updateSuccess': '更新成功',
  'pages.zy-crm.opportunity.message.deleteSuccess': '删除成功',
  'pages.zy-crm.opportunity.message.noCreateApi': '后端未提供新建接口',
  'pages.zy-crm.opportunity.message.noUpdateApi': '后端未提供更新接口',
  'pages.zy-crm.opportunity.message.noDeleteApi': '后端未提供删除接口',
  'pages.zy-crm.opportunity.message.memberLoadFailed':
    '成员列表加载失败，请稍后重试',
  'pages.zy-crm.opportunity.message.memberLoadBlocked':
    '成员列表加载失败，无法提交，请先重试',
  'pages.zy-crm.opportunity.message.detailLoadFailed': '详情加载失败',
  'pages.zy-crm.opportunity.member.unknown': '未知成员',
  'pages.zy-crm.opportunity.state.missingUuid': '缺少 uuid 参数',
  'pages.zy-crm.opportunity.state.detailNotFound': '未找到详情数据',
  'pages.zy-crm.opportunity.state.relationDataEmpty':
    '关联数据可按业务接口补充',
  'pages.zy-crm.opportunity.card.relation': '关联数据',
  'pages.zy-crm.opportunity.field.id': '编号',
  'pages.zy-crm.opportunity.field.name': '商机名称',
  'pages.zy-crm.opportunity.field.customer': '客户',
  'pages.zy-crm.opportunity.field.followUpStatus': '跟进状态',
  'pages.zy-crm.opportunity.field.contactLastTime': '最近联系时间',
  'pages.zy-crm.opportunity.field.contactNextTime': '下次联系时间',
  'pages.zy-crm.opportunity.field.ownerUser': '负责人',
  'pages.zy-crm.opportunity.field.pipeline': '商机管道',
  'pages.zy-crm.opportunity.field.stage': '商机阶段',
  'pages.zy-crm.opportunity.field.endStatus': '结束状态',
  'pages.zy-crm.opportunity.field.dealTime': '成交时间',
  'pages.zy-crm.opportunity.field.totalProductPrice': '产品总价',
  'pages.zy-crm.opportunity.field.discountPercent': '折扣比例',
  'pages.zy-crm.opportunity.field.totalPrice': '合计金额',
  'pages.zy-crm.opportunity.field.remark': '备注',
  'pages.zy-crm.opportunity.field.endRemark': '结束备注',
  'pages.zy-crm.product.title': '产品列表',
  'pages.zy-crm.product.detailTitle': '产品详情',
  'pages.zy-crm.product.card.manageTitle': '产品管理',
  'pages.zy-crm.product.field.name': '产品名称',
  'pages.zy-crm.product.field.code': '产品编码',
  'pages.zy-crm.product.field.unit': '产品单位',
  'pages.zy-crm.product.field.price': '价格',
  'pages.zy-crm.product.field.costPrice': '成本价',
  'pages.zy-crm.product.field.status': '是否上下架',
  'pages.zy-crm.product.field.category': '产品类型',
  'pages.zy-crm.product.field.description': '产品描述',
  'pages.zy-crm.product.field.mainImage': '产品主图',
  'pages.zy-crm.product.field.detailImages': '产品详情图',
  'pages.zy-crm.product.field.owner': '负责人',
  'pages.zy-crm.product.action.refresh': '刷新',
  'pages.zy-crm.product.action.create': '新建',
  'pages.zy-crm.product.action.detail': '详情',
  'pages.zy-crm.product.action.edit': '编辑',
  'pages.zy-crm.product.action.delete': '删除',
  'pages.zy-crm.product.column.operation': '操作',
  'pages.zy-crm.product.modal.createTitle': '新建产品',
  'pages.zy-crm.product.modal.editTitle': '编辑产品',
  'pages.zy-crm.product.modal.deleteTitle': '确认删除',
  'pages.zy-crm.product.modal.deleteContent': '删除后不可恢复，请谨慎操作。',
  'pages.zy-crm.product.form.required': '必填项',
  'pages.zy-crm.product.form.placeholder.input': '请输入{label}',
  'pages.zy-crm.product.form.placeholder.select': '请选择{label}',
  'pages.zy-crm.product.form.placeholder.relation': '请输入关联{label}',
  'pages.zy-crm.product.form.bool.yes': '是',
  'pages.zy-crm.product.form.bool.no': '否',
  'pages.zy-crm.product.form.group.basic': '基础信息',
  'pages.zy-crm.product.form.group.followup': '跟进信息',
  'pages.zy-crm.product.form.group.contact': '联系方式',
  'pages.zy-crm.product.form.group.business': '业务信息',
  'pages.zy-crm.product.form.group.relation': '关联信息',
  'pages.zy-crm.product.form.group.detail': '备注或补充',
  'pages.zy-crm.product.form.group.other': '其他信息',
  'pages.zy-crm.product.form.autoCodeHint': '根据编号规则自动生成',
  'pages.zy-crm.product.enum.status.enabled': '启用/在售',
  'pages.zy-crm.product.enum.status.disabled': '停用/下架',
  'pages.zy-crm.product.message.createSuccess': '创建成功',
  'pages.zy-crm.product.message.updateSuccess': '更新成功',
  'pages.zy-crm.product.message.deleteSuccess': '删除成功',
  'pages.zy-crm.product.message.noCreateApi': '后端未提供新建接口',
  'pages.zy-crm.product.message.noUpdateApi': '后端未提供更新接口',
  'pages.zy-crm.product.message.noDeleteApi': '后端未提供删除接口',
  'pages.zy-crm.product.message.memberLoadFailed':
    '成员列表加载失败，请稍后重试',
  'pages.zy-crm.product.message.memberLoadBlocked':
    '成员列表加载失败，无法提交，请先重试',
  'pages.zy-crm.product.message.categoryLoadFailed':
    '分类列表加载失败，请稍后重试',
  'pages.zy-crm.product.message.categoryLoadBlocked':
    '分类列表加载失败，无法提交，请先重试',
  'pages.zy-crm.product.message.detailLoadFailed': '详情加载失败',
  'pages.zy-crm.product.member.unknown': '未知成员',
  'pages.zy-crm.product.state.missingUuid': '缺少 uuid 参数',
  'pages.zy-crm.product.state.detailNotFound': '未找到详情数据',
  'pages.zy-crm.product.state.relationDataEmpty': '关联数据可按业务接口补充',
  'pages.zy-crm.product.card.relation': '关联数据',
  'pages.zy-crm.contract.title': 'Contract列表',
  'pages.zy-crm.contract.detailTitle': '合同详情',
  'pages.zy-crm.contract.card.manageTitle': 'Contract管理',
  'pages.zy-crm.contract.action.refresh': '刷新',
  'pages.zy-crm.contract.action.create': '新建',
  'pages.zy-crm.contract.action.detail': '详情',
  'pages.zy-crm.contract.action.edit': '编辑',
  'pages.zy-crm.contract.action.delete': '删除',
  'pages.zy-crm.contract.column.operation': '操作',
  'pages.zy-crm.contract.modal.createTitle': '新建',
  'pages.zy-crm.contract.modal.editTitle': '编辑',
  'pages.zy-crm.contract.modal.deleteTitle': '确认删除',
  'pages.zy-crm.contract.modal.deleteContent': '删除后不可恢复，请谨慎操作。',
  'pages.zy-crm.contract.form.required': '必填项',
  'pages.zy-crm.contract.form.placeholder.input': '请输入{label}',
  'pages.zy-crm.contract.form.placeholder.select': '请选择{label}',
  'pages.zy-crm.contract.form.placeholder.relation': '请输入关联{label}',
  'pages.zy-crm.contract.form.bool.yes': '是',
  'pages.zy-crm.contract.form.bool.no': '否',
  'pages.zy-crm.contract.form.group.basic': '基础信息',
  'pages.zy-crm.contract.form.group.followup': '跟进信息',
  'pages.zy-crm.contract.form.group.contact': '联系方式',
  'pages.zy-crm.contract.form.group.business': '业务信息',
  'pages.zy-crm.contract.form.group.relation': '关联信息',
  'pages.zy-crm.contract.form.group.sign': '签约信息',
  'pages.zy-crm.contract.form.group.product': '产品信息',
  'pages.zy-crm.contract.form.group.amount': '金额汇总',
  'pages.zy-crm.contract.form.group.detail': '备注或补充',
  'pages.zy-crm.contract.form.group.other': '其他信息',
  'pages.zy-crm.contract.form.autoCodeHint': '根据编号规则自动生成',
  'pages.zy-crm.contract.message.createSuccess': '创建成功',
  'pages.zy-crm.contract.message.updateSuccess': '更新成功',
  'pages.zy-crm.contract.message.deleteSuccess': '删除成功',
  'pages.zy-crm.contract.message.noCreateApi': '后端未提供新建接口',
  'pages.zy-crm.contract.message.noUpdateApi': '后端未提供更新接口',
  'pages.zy-crm.contract.message.noDeleteApi': '后端未提供删除接口',
  'pages.zy-crm.contract.message.memberLoadFailed':
    '成员列表加载失败，请稍后重试',
  'pages.zy-crm.contract.message.customerLoadFailed':
    '客户列表加载失败，请稍后重试',
  'pages.zy-crm.contract.message.opportunityLoadFailed':
    '商机列表加载失败，请稍后重试',
  'pages.zy-crm.contract.message.memberLoadBlocked':
    '成员列表加载失败，无法提交，请先重试',
  'pages.zy-crm.contract.message.detailLoadFailed': '详情加载失败',
  'pages.zy-crm.contract.message.loadDetailFailed': '加载合同详情失败',
  'pages.zy-crm.contract.message.productEmpty': '请至少添加一个产品明细',
  'pages.zy-crm.contract.member.unknown': '未知成员',
  'pages.zy-crm.contract.state.missingUuid': '缺少 uuid 参数',
  'pages.zy-crm.contract.state.detailNotFound': '未找到详情数据',
  'pages.zy-crm.contract.state.relationDataEmpty': '关联数据可按业务接口补充',
  'pages.zy-crm.contract.card.relation': '关联数据',
  'pages.zy-crm.contract.card.productDetail': '产品明细',
  'pages.zy-crm.contract.search.expand': '展开',
  'pages.zy-crm.contract.search.collapse': '收起',
  'pages.zy-crm.contract.enum.type.standard': '标准合同',
  'pages.zy-crm.contract.enum.type.framework': '框架合同',
  'pages.zy-crm.contract.enum.type.supplement': '补充协议',
  'pages.zy-crm.contract.action.addProduct': '添加产品',
  'pages.zy-crm.contract.action.addRow': '添加行',
  'pages.zy-crm.contract.table.emptyProducts': '暂无产品明细',
  'pages.zy-crm.contract.field.id': 'ID',
  'pages.zy-crm.contract.field.name': '名称',
  'pages.zy-crm.contract.field.code': '合同编号',
  'pages.zy-crm.contract.field.customer': '客户',
  'pages.zy-crm.contract.field.opportunity': '商机',
  'pages.zy-crm.contract.field.contactLastTime': '最近联系时间',
  'pages.zy-crm.contract.field.ownerUser': '负责人',
  'pages.zy-crm.contract.field.processInstance': '流程实例',
  'pages.zy-crm.contract.field.auditStatus': '审批状态',
  'pages.zy-crm.contract.field.orderDate': '下单日期',
  'pages.zy-crm.contract.field.startTime': '开始时间',
  'pages.zy-crm.contract.field.endTime': '结束时间',
  'pages.zy-crm.contract.field.contractType': '合同类型',
  'pages.zy-crm.contract.field.customerSigner': '客户签约人',
  'pages.zy-crm.contract.field.companySignerUserUuid': '公司签约人',
  'pages.zy-crm.contract.field.signContactUuid': '签约联系人',
  'pages.zy-crm.contract.field.signUserUuid': '签约人',
  'pages.zy-crm.contract.field.contractImageUrl': '合同影像',
  'pages.zy-crm.contract.field.totalProductPrice': '产品总价',
  'pages.zy-crm.contract.field.discountPercent': '折扣比例',
  'pages.zy-crm.contract.field.totalPrice': '合同总价',
  'pages.zy-crm.contract.field.profitAmount': '利润',
  'pages.zy-crm.contract.field.productName': '产品名称',
  'pages.zy-crm.contract.field.productType': '产品类型',
  'pages.zy-crm.contract.field.productUnit': '产品单位',
  'pages.zy-crm.contract.field.listPrice': '价格',
  'pages.zy-crm.contract.field.costPrice': '成本价',
  'pages.zy-crm.contract.field.salePrice': '售价',
  'pages.zy-crm.contract.field.quantity': '数量',
  'pages.zy-crm.contract.field.lineTotal': '小计',
  'pages.zy-crm.contract.field.signContact': '签约联系人',
  'pages.zy-crm.contract.field.signUser': '签约人',
  'pages.zy-crm.contract.field.remark': '备注',
  'pages.zy-crm.contract.field.customerUuid': '客户名称',
  'pages.zy-crm.contract.field.opportunityUuid': '商机名称',
  'pages.zy-crm.contract.field.ownerUserUuid': '负责人',
  'pages.zy-crm.contract.field.processInstanceUuid': '流程实例',
  'pages.zy-crm.contractCodeRule.title': '合同编号规则',
  'pages.zy-crm.contractCodeRule.cardTitle': '合同编号规则',
  'pages.zy-crm.contractCodeRule.action.save': '保存',
  'pages.zy-crm.contractCodeRule.action.reset': '重置',
  'pages.zy-crm.contractCodeRule.message.saveSuccess': '合同编号规则保存成功',
  'pages.zy-crm.contractCodeRule.message.loadFailed': '加载合同编号规则失败',
  'pages.zy-crm.contractCodeRule.message.saveFailed': '保存合同编号规则失败',
  'pages.zy-crm.contractCodeRule.form.required': '必填项',
  'pages.zy-crm.contractCodeRule.field.prefix': '编号前缀',
  'pages.zy-crm.contractCodeRule.field.dateFormat': '日期格式',
  'pages.zy-crm.contractCodeRule.field.seqLength': '流水号位数',
  'pages.zy-crm.contractCodeRule.field.resetCycle': '重置周期',
  'pages.zy-crm.contractCodeRule.preview.label': '下一编号预览',
  'pages.zy-crm.contractCodeRule.enum.date.none': '不使用日期',
  'pages.zy-crm.contractCodeRule.enum.date.yymm': 'YYMM',
  'pages.zy-crm.contractCodeRule.enum.date.yyyymmdd': 'YYYYMMDD',
  'pages.zy-crm.contractCodeRule.enum.cycle.none': '不重置',
  'pages.zy-crm.contractCodeRule.enum.cycle.year': '按年重置',
  'pages.zy-crm.contractCodeRule.enum.cycle.month': '按月重置',
  'pages.zy-crm.productCodeRule.title': '产品编号规则',
  'pages.zy-crm.productCodeRule.cardTitle': '产品编号规则',
  'pages.zy-crm.productCodeRule.action.save': '保存',
  'pages.zy-crm.productCodeRule.action.reset': '重置',
  'pages.zy-crm.productCodeRule.message.saveSuccess': '产品编号规则保存成功',
  'pages.zy-crm.productCodeRule.message.loadFailed': '加载产品编号规则失败',
  'pages.zy-crm.productCodeRule.message.saveFailed': '保存产品编号规则失败',
  'pages.zy-crm.productCodeRule.form.required': '必填项',
  'pages.zy-crm.productCodeRule.field.prefix': '编号前缀',
  'pages.zy-crm.productCodeRule.field.dateFormat': '日期格式',
  'pages.zy-crm.productCodeRule.field.seqLength': '流水号位数',
  'pages.zy-crm.productCodeRule.field.resetCycle': '重置周期',
  'pages.zy-crm.productCodeRule.preview.label': '下一编号预览',
  'pages.zy-crm.productCodeRule.enum.date.none': '不使用日期',
  'pages.zy-crm.productCodeRule.enum.date.yymm': 'YYMM',
  'pages.zy-crm.productCodeRule.enum.date.yyyymmdd': 'YYYYMMDD',
  'pages.zy-crm.productCodeRule.enum.cycle.none': '不重置',
  'pages.zy-crm.productCodeRule.enum.cycle.year': '按年重置',
  'pages.zy-crm.productCodeRule.enum.cycle.month': '按月重置',
  'pages.zy-crm.receipt.title': '回款列表',
  'pages.zy-crm.receipt.card.manageTitle': '回款管理',
  'pages.zy-crm.receipt.action.refresh': '刷新',
  'pages.zy-crm.receipt.action.create': '新建',
  'pages.zy-crm.receipt.action.detail': '详情',
  'pages.zy-crm.receipt.action.edit': '编辑',
  'pages.zy-crm.receipt.action.delete': '删除',
  'pages.zy-crm.receipt.column.operation': '操作',
  'pages.zy-crm.receipt.modal.createTitle': '新建',
  'pages.zy-crm.receipt.modal.editTitle': '编辑',
  'pages.zy-crm.receipt.modal.deleteTitle': '确认删除',
  'pages.zy-crm.receipt.modal.deleteContent': '删除后不可恢复，请谨慎操作。',
  'pages.zy-crm.receipt.form.required': '必填项',
  'pages.zy-crm.receipt.form.placeholder.input': '请输入{label}',
  'pages.zy-crm.receipt.form.placeholder.select': '请选择{label}',
  'pages.zy-crm.receipt.form.placeholder.relation': '请输入关联{label}',
  'pages.zy-crm.receipt.form.bool.yes': '是',
  'pages.zy-crm.receipt.form.bool.no': '否',
  'pages.zy-crm.receipt.form.group.basic': '基础信息',
  'pages.zy-crm.receipt.form.group.followup': '跟进信息',
  'pages.zy-crm.receipt.form.group.contact': '联系方式',
  'pages.zy-crm.receipt.form.group.business': '业务信息',
  'pages.zy-crm.receipt.form.group.relation': '关联信息',
  'pages.zy-crm.receipt.form.group.detail': '备注或补充',
  'pages.zy-crm.receipt.form.group.other': '其他信息',
  'pages.zy-crm.receipt.message.createSuccess': '创建成功',
  'pages.zy-crm.receipt.message.updateSuccess': '更新成功',
  'pages.zy-crm.receipt.message.deleteSuccess': '删除成功',
  'pages.zy-crm.receipt.message.noCreateApi': '后端未提供新建接口',
  'pages.zy-crm.receipt.message.noUpdateApi': '后端未提供更新接口',
  'pages.zy-crm.receipt.message.noDeleteApi': '后端未提供删除接口',
  'pages.zy-crm.receipt.message.memberLoadFailed':
    '成员列表加载失败，请稍后重试',
  'pages.zy-crm.receipt.message.memberLoadBlocked':
    '成员列表加载失败，无法提交，请先重试',
  'pages.zy-crm.receipt.message.detailLoadFailed': '详情加载失败',
  'pages.zy-crm.receipt.member.unknown': '未知成员',
  'pages.zy-crm.receipt.state.missingUuid': '缺少 uuid 参数',
  'pages.zy-crm.receipt.state.detailNotFound': '未找到详情数据',
  'pages.zy-crm.receipt.state.relationDataEmpty': '关联数据可按业务接口补充',
  'pages.zy-crm.receipt.card.relation': '关联数据',
  'pages.zy-crm.receipt.search.expand': '展开',
  'pages.zy-crm.receipt.search.collapse': '收起',
  'pages.zy-crm.receipt.field.id': 'ID',
  'pages.zy-crm.receipt.field.code': '回款编号',
  'pages.zy-crm.receipt.field.receiptScheduleUuid': '回款计划',
  'pages.zy-crm.receipt.field.customerUuid': '客户',
  'pages.zy-crm.receipt.field.contractUuid': '合同',
  'pages.zy-crm.receipt.field.ownerUserUuid': '负责人',
  'pages.zy-crm.receipt.field.auditStatus': '审批状态',
  'pages.zy-crm.receipt.field.processInstanceUuid': '流程实例',
  'pages.zy-crm.receipt.field.receiptDate': '回款日期',
  'pages.zy-crm.receipt.field.receiptMethod': '回款方式',
  'pages.zy-crm.receipt.field.price': '回款金额',
  'pages.zy-crm.receipt.field.remark': '备注',
  'pages.zy-crm.receipt.placeholder.autoCode': '根据系统规则自动生成',
  'pages.zy-crm.receipt-schedule.title': '回款计划列表',
  'pages.zy-crm.receipt-schedule.detailTitle': '回款计划详情',
  'pages.zy-crm.receipt-schedule.card.manageTitle': '回款计划管理',
  'pages.zy-crm.receipt-schedule.action.refresh': '刷新',
  'pages.zy-crm.receipt-schedule.action.create': '新建',
  'pages.zy-crm.receipt-schedule.action.detail': '详情',
  'pages.zy-crm.receipt-schedule.action.edit': '编辑',
  'pages.zy-crm.receipt-schedule.action.delete': '删除',
  'pages.zy-crm.receipt-schedule.column.operation': '操作',
  'pages.zy-crm.receipt-schedule.modal.createTitle': '新建',
  'pages.zy-crm.receipt-schedule.modal.editTitle': '编辑',
  'pages.zy-crm.receipt-schedule.modal.deleteTitle': '确认删除',
  'pages.zy-crm.receipt-schedule.modal.deleteContent':
    '删除后不可恢复，请谨慎操作。',
  'pages.zy-crm.receipt-schedule.form.required': '必填项',
  'pages.zy-crm.receipt-schedule.form.placeholder.input': '请输入{label}',
  'pages.zy-crm.receipt-schedule.form.placeholder.select': '请选择{label}',
  'pages.zy-crm.receipt-schedule.form.placeholder.relation':
    '请输入关联{label}',
  'pages.zy-crm.receipt-schedule.form.bool.yes': '是',
  'pages.zy-crm.receipt-schedule.form.bool.no': '否',
  'pages.zy-crm.receipt-schedule.form.group.basic': '基础信息',
  'pages.zy-crm.receipt-schedule.form.group.followup': '跟进信息',
  'pages.zy-crm.receipt-schedule.form.group.contact': '联系方式',
  'pages.zy-crm.receipt-schedule.form.group.business': '业务信息',
  'pages.zy-crm.receipt-schedule.form.group.relation': '关联信息',
  'pages.zy-crm.receipt-schedule.form.group.detail': '备注或补充',
  'pages.zy-crm.receipt-schedule.form.group.other': '其他信息',
  'pages.zy-crm.receipt-schedule.message.createSuccess': '创建成功',
  'pages.zy-crm.receipt-schedule.message.updateSuccess': '更新成功',
  'pages.zy-crm.receipt-schedule.message.deleteSuccess': '删除成功',
  'pages.zy-crm.receipt-schedule.message.noCreateApi': '后端未提供新建接口',
  'pages.zy-crm.receipt-schedule.message.noUpdateApi': '后端未提供更新接口',
  'pages.zy-crm.receipt-schedule.message.noDeleteApi': '后端未提供删除接口',
  'pages.zy-crm.receipt-schedule.message.memberLoadFailed':
    '成员列表加载失败，请稍后重试',
  'pages.zy-crm.receipt-schedule.message.memberLoadBlocked':
    '成员列表加载失败，无法提交，请先重试',
  'pages.zy-crm.receipt-schedule.message.detailLoadFailed': '详情加载失败',
  'pages.zy-crm.receipt-schedule.member.unknown': '未知成员',
  'pages.zy-crm.receipt-schedule.state.missingUuid': '缺少 uuid 参数',
  'pages.zy-crm.receipt-schedule.state.detailNotFound': '未找到详情数据',
  'pages.zy-crm.receipt-schedule.state.relationDataEmpty':
    '关联数据可按业务接口补充',
  'pages.zy-crm.receipt-schedule.card.relation': '关联数据',
  'pages.zy-crm.receipt-schedule.search.expand': '展开',
  'pages.zy-crm.receipt-schedule.search.collapse': '收起',
  'pages.zy-crm.receipt-schedule.field.id': 'ID',
  'pages.zy-crm.receipt-schedule.field.period': '期次',
  'pages.zy-crm.receipt-schedule.field.customerUuid': '客户',
  'pages.zy-crm.receipt-schedule.field.contractUuid': '合同',
  'pages.zy-crm.receipt-schedule.field.ownerUserUuid': '负责人',
  'pages.zy-crm.receipt-schedule.field.receiptUuid': '关联回款',
  'pages.zy-crm.receipt-schedule.field.receiptDate': '计划回款日期',
  'pages.zy-crm.receipt-schedule.field.receiptMethod': '计划回款方式',
  'pages.zy-crm.receipt-schedule.field.price': '计划回款金额',
  'pages.zy-crm.receipt-schedule.field.receivedAmount': '已回款金额',
  'pages.zy-crm.receipt-schedule.field.unpaidAmount': '未回款金额',
  'pages.zy-crm.receipt-schedule.field.remindDays': '提前提醒天数',
  'pages.zy-crm.receipt-schedule.field.remindTime': '提醒时间',
  'pages.zy-crm.receipt-schedule.field.status': '执行状态',
  'pages.zy-crm.receipt-schedule.field.systemStatus': '系统状态',
  'pages.zy-crm.receipt-schedule.field.remark': '备注',
  'pages.zy-crm.receipt.option.receiptMethod.bankTransfer': '银行转账',
  'pages.zy-crm.receipt.option.receiptMethod.cash': '现金',
  'pages.zy-crm.receipt.option.receiptMethod.check': '支票',
  'pages.zy-crm.receipt.option.receiptMethod.other': '其他',
  'pages.zy-crm.receipt.option.status.draft': '草稿',
  'pages.zy-crm.receipt.option.status.pending': '审批中',
  'pages.zy-crm.receipt.option.status.approved': '已通过',
  'pages.zy-crm.receipt.option.status.rejected': '已拒绝',
  'pages.zy-crm.receipt-schedule.option.status.pending': '待执行',
  'pages.zy-crm.receipt-schedule.option.status.completed': '已完成',
  'pages.zy-crm.calendar.title': '日历',
  'pages.zy-crm.calendar.action.today': '今天',
  'pages.zy-crm.calendar.action.prev': '上一个',
  'pages.zy-crm.calendar.action.next': '下一个',
  'pages.zy-crm.calendar.action.create': '创建',
  'pages.zy-crm.calendar.action.refresh': '刷新',
  'pages.zy-crm.calendar.action.save': '保存',
  'pages.zy-crm.calendar.action.delete': '删除',
  'pages.zy-crm.calendar.action.openSource': '打开来源记录',
  'pages.zy-crm.calendar.view.day': '日',
  'pages.zy-crm.calendar.view.week': '周',
  'pages.zy-crm.calendar.view.month': '月',
  'pages.zy-crm.calendar.view.list': '列表',
  'pages.zy-crm.calendar.sidebar.mySchedule': '我的日程',
  'pages.zy-crm.calendar.sidebar.systemType': '系统类型',
  'pages.zy-crm.calendar.sidebar.otherCalendar': '其他日历',
  'pages.zy-crm.calendar.filter.my_schedule': '我的日程',
  'pages.zy-crm.calendar.filter.assigned_task': '分配的任务',
  'pages.zy-crm.calendar.filter.phone_communication': '电话沟通',
  'pages.zy-crm.calendar.filter.send_email': '发邮件',
  'pages.zy-crm.calendar.filter.online_meeting': '线上会议',
  'pages.zy-crm.calendar.filter.visit': '见面拜访',
  'pages.zy-crm.calendar.filter.send_sms': '发短信',
  'pages.zy-crm.calendar.filter.lead_follow_up': '需联系的线索',
  'pages.zy-crm.calendar.filter.customer_follow_up': '需联系的客户',
  'pages.zy-crm.calendar.filter.contact_follow_up': '需联系的联系人',
  'pages.zy-crm.calendar.filter.opportunity_follow_up': '需联系的商机',
  'pages.zy-crm.calendar.filter.opportunity_deal': '预计成交商机',
  'pages.zy-crm.calendar.filter.contract_expire': '即将到期的合同',
  'pages.zy-crm.calendar.filter.receipt_schedule': '计划回款',
  'pages.zy-crm.calendar.drawer.createTitle': '新建日程',
  'pages.zy-crm.calendar.drawer.editTitle': '编辑日程',
  'pages.zy-crm.calendar.drawer.detailTitle': '日程详情',
  'pages.zy-crm.calendar.form.title': '标题',
  'pages.zy-crm.calendar.form.eventType': '类型',
  'pages.zy-crm.calendar.form.startTime': '开始时间',
  'pages.zy-crm.calendar.form.endTime': '结束时间',
  'pages.zy-crm.calendar.form.allDay': '全天',
  'pages.zy-crm.calendar.form.location': '地点',
  'pages.zy-crm.calendar.form.description': '描述',
  'pages.zy-crm.calendar.form.color': '颜色',
  'pages.zy-crm.calendar.form.placeholder.title': '请输入标题',
  'pages.zy-crm.calendar.form.placeholder.location': '请输入地点',
  'pages.zy-crm.calendar.message.loadFailed': '日历数据加载失败',
  'pages.zy-crm.calendar.message.createSuccess': '日程已创建',
  'pages.zy-crm.calendar.message.updateSuccess': '日程已更新',
  'pages.zy-crm.calendar.message.deleteSuccess': '日程已删除',
  'pages.zy-crm.calendar.message.saveFailed': '保存失败，请稍后重试',
  'pages.zy-crm.calendar.message.deleteFailed': '删除失败，请稍后重试',
  'pages.zy-crm.calendar.empty.noEventType': '请至少选择一种日历类型',
  'pages.zy-crm.calendar.readonly.system': '系统事件不支持编辑',
  'pages.zy-crm.quote.title': '报价单列表',
  'pages.zy-crm.quote.detailTitle': '报价单详情',
  'pages.zy-crm.quote.action.refresh': '刷新',
  'pages.zy-crm.quote.action.create': '新建',
  'pages.zy-crm.quote.action.codeRule': '编号规则',
  'pages.zy-crm.quote.action.detail': '详情',
  'pages.zy-crm.quote.action.edit': '编辑',
  'pages.zy-crm.quote.action.delete': '删除',
  'pages.zy-crm.quote.action.restore': '恢复',
  'pages.zy-crm.quote.action.reuse': '复用',
  'pages.zy-crm.quote.action.history': '查看/复用历史报价',
  'pages.zy-crm.quote.action.search': '搜索',
  'pages.zy-crm.quote.action.addProduct': '添加产品',
  'pages.zy-crm.quote.action.addRow': '添加行',
  'pages.zy-crm.quote.action.saveCodeRule': '保存规则',
  'pages.zy-crm.quote.column.operation': '操作',
  'pages.zy-crm.quote.modal.createTitle': '新建报价单',
  'pages.zy-crm.quote.modal.editTitle': '编辑报价单',
  'pages.zy-crm.quote.modal.deleteTitle': '确认删除',
  'pages.zy-crm.quote.modal.deleteContent': '删除后不可恢复，请谨慎操作。',
  'pages.zy-crm.quote.modal.restoreTitle': '是否恢复该报价单？',
  'pages.zy-crm.quote.modal.restoreContent': '可立即撤销本次删除操作。',
  'pages.zy-crm.quote.modal.historyTitle': '历史报价',
  'pages.zy-crm.quote.modal.diffTitle': '报价金额差异确认',
  'pages.zy-crm.quote.modal.diffContent':
    '手工总额与明细计算值差异为 {diff}，确认继续提交吗？',
  'pages.zy-crm.quote.modal.crossCustomerTitle': '跨客户复用确认',
  'pages.zy-crm.quote.modal.crossCustomerContent':
    '当前客户与历史报价客户不一致，确认继续将覆盖客户信息吗？',
  'pages.zy-crm.quote.modal.codeRuleTitle': '报价编号规则',
  'pages.zy-crm.quote.form.required': '必填项',
  'pages.zy-crm.quote.form.autoCodeHint': '根据编号规则自动生成',
  'pages.zy-crm.quote.form.placeholder.input': '请输入{label}',
  'pages.zy-crm.quote.form.placeholder.select': '请选择{label}',
  'pages.zy-crm.quote.form.group.basic': '基础信息',
  'pages.zy-crm.quote.form.group.relation': '关联信息',
  'pages.zy-crm.quote.form.group.date': '日期信息',
  'pages.zy-crm.quote.form.group.product': '产品信息',
  'pages.zy-crm.quote.form.group.amount': '金额汇总',
  'pages.zy-crm.quote.form.group.remark': '备注',
  'pages.zy-crm.quote.message.createSuccess': '创建成功',
  'pages.zy-crm.quote.message.updateSuccess': '更新成功',
  'pages.zy-crm.quote.message.deleteSuccess': '删除成功',
  'pages.zy-crm.quote.message.restoreSuccess': '恢复成功',
  'pages.zy-crm.quote.message.reuseSuccess': '历史报价复用成功',
  'pages.zy-crm.quote.message.memberLoadFailed': '成员列表加载失败，请稍后重试',
  'pages.zy-crm.quote.message.memberLoadBlocked':
    '成员列表加载失败，无法提交，请先重试',
  'pages.zy-crm.quote.message.customerLoadFailed':
    '客户列表加载失败，请稍后重试',
  'pages.zy-crm.quote.message.contactLoadFailed':
    '联系人列表加载失败，请稍后重试',
  'pages.zy-crm.quote.message.opportunityLoadFailed':
    '商机列表加载失败，请稍后重试',
  'pages.zy-crm.quote.message.productLoadFailed':
    '产品列表加载失败，请稍后重试',
  'pages.zy-crm.quote.message.historyLoadFailed': '历史报价加载失败',
  'pages.zy-crm.quote.message.productEmpty': '请至少添加一个产品明细',
  'pages.zy-crm.quote.message.detailLoadFailed': '详情加载失败',
  'pages.zy-crm.quote.message.codeRuleLoadFailed': '报价编号规则加载失败',
  'pages.zy-crm.quote.message.codeRuleUpdateSuccess': '编号规则更新成功',
  'pages.zy-crm.quote.search.expand': '展开',
  'pages.zy-crm.quote.search.collapse': '收起',
  'pages.zy-crm.quote.state.diffNeedsConfirm': '金额差异未确认，已取消提交',
  'pages.zy-crm.quote.state.missingUuid': '缺少 uuid 参数',
  'pages.zy-crm.quote.state.detailNotFound': '未找到详情数据',
  'pages.zy-crm.quote.history.range.lastMonth': '最近一个月',
  'pages.zy-crm.quote.history.range.halfYear': '近半年',
  'pages.zy-crm.quote.history.range.thisYear': '本年度',
  'pages.zy-crm.quote.table.emptyProducts': '暂无产品明细',
  'pages.zy-crm.quote.table.emptyHistory': '暂无历史报价',
  'pages.zy-crm.quote.stats.selectedProducts': '已选中产品：{count} 种',
  'pages.zy-crm.quote.stats.quoteAmount': '总金额：{amount} 元',
  'pages.zy-crm.quote.option.dateFormat.none': '无日期',
  'pages.zy-crm.quote.option.dateFormat.yymm': '年/月(YYMM)',
  'pages.zy-crm.quote.option.dateFormat.yyyymmdd': '年/月/日(YYYYMMDD)',
  'pages.zy-crm.quote.option.resetCycle.none': '不重置',
  'pages.zy-crm.quote.option.resetCycle.year': '按年重置',
  'pages.zy-crm.quote.option.resetCycle.month': '按月重置',
  'pages.zy-crm.quote.status.approved': '已通过',
  'pages.zy-crm.quote.status.submitted': '审批中',
  'pages.zy-crm.quote.status.rejected': '已拒绝',
  'pages.zy-crm.quote.status.draft': '草稿',
  'pages.zy-crm.quote.field.code': '报价单编号',
  'pages.zy-crm.quote.field.name': '报价单名称',
  'pages.zy-crm.quote.field.customerUuid': '客户名称',
  'pages.zy-crm.quote.field.contactUuid': '客户联系人',
  'pages.zy-crm.quote.field.opportunityUuid': '商机名称',
  'pages.zy-crm.quote.field.quoteDate': '报价日期',
  'pages.zy-crm.quote.field.expectedDealDate': '预计成交日期',
  'pages.zy-crm.quote.field.ownerUserUuid': '负责人',
  'pages.zy-crm.quote.field.ownerMobile': '负责人手机号',
  'pages.zy-crm.quote.field.auditStatus': '审核状态',
  'pages.zy-crm.quote.field.discountPercent': '整单折扣(%)',
  'pages.zy-crm.quote.field.totalProductPrice': '产品成本总金额',
  'pages.zy-crm.quote.field.totalPrice': '报价金额',
  'pages.zy-crm.quote.field.profitAmount': '利润',
  'pages.zy-crm.quote.field.remark': '备注',
  'pages.zy-crm.quote.field.sourceQuoteUuid': '来源报价单',
  'pages.zy-crm.quote.field.products': '产品',
  'pages.zy-crm.quote.field.productName': '产品名称',
  'pages.zy-crm.quote.field.productType': '产品类型',
  'pages.zy-crm.quote.field.productUnit': '产品单位',
  'pages.zy-crm.quote.field.listPrice': '价格',
  'pages.zy-crm.quote.field.costPrice': '成本价',
  'pages.zy-crm.quote.field.salePrice': '售价',
  'pages.zy-crm.quote.field.quantity': '数量',
  'pages.zy-crm.quote.field.lineTotal': '小计',
  'pages.zy-crm.quote.field.historyRange': '时间范围',
  'pages.zy-crm.quote.field.historyKeyword': '关键字',
  'pages.zy-crm.quote.field.dateFormat': '日期格式',
  'pages.zy-crm.quote.field.resetCycle': '重置周期',
  'pages.zy-crm.quote.field.seqLength': '序号位数',
  'pages.zy-crm.quote.field.prefix': '前缀',
  'pages.zy-crm.followUps.title': '跟进记录列表',
  'pages.zy-crm.invoice.title': '发票列表',
  'pages.zy-crm.invoice.detailTitle': '发票详情',
  'pages.zy-crm.invoice.action.refresh': '刷新',
  'pages.zy-crm.invoice.action.create': '新建发票',
  'pages.zy-crm.invoice.action.detail': '详情',
  'pages.zy-crm.invoice.action.edit': '编辑',
  'pages.zy-crm.invoice.action.delete': '删除',
  'pages.zy-crm.invoice.action.submit': '提交审核',
  'pages.zy-crm.invoice.action.addItem': '添加明细',
  'pages.zy-crm.invoice.action.back': '返回列表',
  'pages.zy-crm.invoice.action.save': '保存',
  'pages.zy-crm.invoice.action.cancel': '取消',
  'pages.zy-crm.invoice.action.manageProfile': '管理发票信息',
  'pages.zy-crm.invoice.action.selectProfile': '选择发票信息',
  'pages.zy-crm.invoice.modal.createTitle': '新建发票',
  'pages.zy-crm.invoice.modal.editTitle': '编辑发票',
  'pages.zy-crm.invoice.modal.deleteTitle': '确认删除',
  'pages.zy-crm.invoice.modal.deleteContent': '删除后不可恢复，请谨慎操作。',
  'pages.zy-crm.invoice.column.operation': '操作',
  'pages.zy-crm.invoice.search.expand': '展开',
  'pages.zy-crm.invoice.search.collapse': '收起',
  'pages.zy-crm.invoice.form.group.basic': '基本信息',
  'pages.zy-crm.invoice.form.group.invoice': '发票信息',
  'pages.zy-crm.invoice.form.placeholder.input': '请输入{label}',
  'pages.zy-crm.invoice.form.placeholder.select': '请选择{label}',
  'pages.zy-crm.invoice.form.required': '必填项',
  'pages.zy-crm.invoice.message.createSuccess': '创建成功',
  'pages.zy-crm.invoice.message.updateSuccess': '更新成功',
  'pages.zy-crm.invoice.message.deleteSuccess': '删除成功',
  'pages.zy-crm.invoice.message.submitSuccess': '提交审核成功',
  'pages.zy-crm.invoice.message.detailLoadFailed': '详情加载失败',
  'pages.zy-crm.invoice.message.profileRequired': '请选择发票信息',
  'pages.zy-crm.invoice.message.manualSnapshotRequired':
    '请输入抬头类型、开票抬头和税号',
  'pages.zy-crm.invoice.message.contractRequired': '请先选择合同',
  'pages.zy-crm.invoice.message.itemsRequired': '请至少添加一条回款明细',
  'pages.zy-crm.invoice.message.receiptCandidatesLoadFailed':
    '回款明细加载失败',
  'pages.zy-crm.invoice.member.unknown': '未知成员',
  'pages.zy-crm.invoice.state.missingUuid': '缺少 uuid 参数',
  'pages.zy-crm.invoice.state.detailNotFound': '未找到详情数据',
  'pages.zy-crm.invoice.state.emptyItems': '暂无数据',
  'pages.zy-crm.invoice.state.relationDataEmpty': '关联数据可按业务接口补充',
  'pages.zy-crm.invoice.placeholder.autoCode': '根据编号规则自动生成',
  'pages.zy-crm.invoice.field.code': '发票申请编号',
  'pages.zy-crm.invoice.field.customerUuid': '客户名称',
  'pages.zy-crm.invoice.field.customerName': '客户名称',
  'pages.zy-crm.invoice.field.contractUuid': '合同',
  'pages.zy-crm.invoice.field.contractName': '合同名称',
  'pages.zy-crm.invoice.field.ownerUserUuid': '负责人',
  'pages.zy-crm.invoice.field.invoiceDate': '开票日期',
  'pages.zy-crm.invoice.field.invoiceType': '开票类型',
  'pages.zy-crm.invoice.field.auditStatus': '审核状态',
  'pages.zy-crm.invoice.field.processInstanceUuid': '流程实例',
  'pages.zy-crm.invoice.field.invoiceProfileName': '抬头名称',
  'pages.zy-crm.invoice.field.totalAmount': '开票金额',
  'pages.zy-crm.invoice.field.remark': '备注',
  'pages.zy-crm.invoice.field.invoiceProfileUuid': '发票信息',
  'pages.zy-crm.invoice.field.titleType': '抬头类型',
  'pages.zy-crm.invoice.field.titleSnapshot': '开票抬头',
  'pages.zy-crm.invoice.field.taxNoSnapshot': '纳税人识别号',
  'pages.zy-crm.invoice.field.bankNameSnapshot': '开户行',
  'pages.zy-crm.invoice.field.bankAccountSnapshot': '开户账号',
  'pages.zy-crm.invoice.field.addressSnapshot': '开户地址',
  'pages.zy-crm.invoice.field.phoneSnapshot': '电话',
  'pages.zy-crm.invoice.field.saveAsProfile': '保存为常用发票信息',
  'pages.zy-crm.invoice.field.mailContact': '联系人',
  'pages.zy-crm.invoice.field.mailPhone': '联系方式',
  'pages.zy-crm.invoice.field.mailAddressRegion': '邮寄地址',
  'pages.zy-crm.invoice.field.mailAddressDetail': '详细地址',
  'pages.zy-crm.invoice.field.items': '回款明细',
  'pages.zy-crm.invoice.section.items': '回款明细',
  'pages.zy-crm.invoice.field.receiptCode': '回款编号',
  'pages.zy-crm.invoice.field.receiptScheduleCode': '回款计划编号',
  'pages.zy-crm.invoice.field.receiptAmount': '回款金额',
  'pages.zy-crm.invoice.field.contractCode': '合同编号',
  'pages.zy-crm.invoice.field.contractAmount': '合同金额',
  'pages.zy-crm.invoice.field.uninvoicedAmount': '未开票金额',
  'pages.zy-crm.invoice.field.receiptUninvoicedAmount': '该笔回款可开票金额',
  'pages.zy-crm.invoice.field.invoiceAmount': '本次开票金额',
  'pages.zy-crm.invoice.field.receiptDate': '回款日期',
  'pages.zy-crm.invoice.field.receiptMethod': '回款方式',
  'pages.zy-crm.invoice.field.createdAt': '创建时间',
  'pages.zy-crm.invoice.option.type.normal': '普通发票',
  'pages.zy-crm.invoice.option.type.special': '专用发票',
  'pages.zy-crm.invoice.option.title.company': '单位',
  'pages.zy-crm.invoice.option.title.personal': '个人',
  'pages.zy-crm.invoice.option.status.draft': '草稿',
  'pages.zy-crm.invoice.option.status.pending': '待审核',
  'pages.zy-crm.invoice.option.status.approved': '已通过',
  'pages.zy-crm.invoice.option.status.rejected': '已驳回',
  'pages.zy-crm.invoice.section.mailing': '邮寄信息',
  'pages.zy-crm.invoice.card.relation': '关联信息',
  'pages.zy-crm.invoice.card.invoiceInfo': '发票信息',
  'pages.zy-crm.invoice.card.mailing': '邮寄信息',
  'pages.zy-crm.invoice-profile.title': '发票信息管理',
  'pages.zy-crm.invoice-profile.action.refresh': '刷新',
  'pages.zy-crm.invoice-profile.action.create': '新建发票信息',
  'pages.zy-crm.invoice-profile.action.edit': '编辑',
  'pages.zy-crm.invoice-profile.action.delete': '删除',
  'pages.zy-crm.invoice-profile.column.operation': '操作',
  'pages.zy-crm.invoice-profile.modal.createTitle': '新建发票信息',
  'pages.zy-crm.invoice-profile.modal.editTitle': '编辑发票信息',
  'pages.zy-crm.invoice-profile.modal.deleteTitle': '确认删除',
  'pages.zy-crm.invoice-profile.modal.deleteContent':
    '删除后不可恢复，请谨慎操作。',
  'pages.zy-crm.invoice-profile.form.required': '必填项',
  'pages.zy-crm.invoice-profile.message.createSuccess': '创建成功',
  'pages.zy-crm.invoice-profile.message.updateSuccess': '更新成功',
  'pages.zy-crm.invoice-profile.message.deleteSuccess': '删除成功',
  'pages.zy-crm.invoice-profile.message.detailLoadFailed': '详情加载失败',
  'pages.zy-crm.invoice-profile.field.name': '档案名称',
  'pages.zy-crm.invoice-profile.field.type': '抬头类型',
  'pages.zy-crm.invoice-profile.field.title': '开票抬头',
  'pages.zy-crm.invoice-profile.field.taxNo': '税号',
  'pages.zy-crm.invoice-profile.field.bankName': '开户行',
  'pages.zy-crm.invoice-profile.field.bankAccount': '开户账号',
  'pages.zy-crm.invoice-profile.field.address': '开户地址',
  'pages.zy-crm.invoice-profile.field.phone': '电话',
  'pages.zy-crm.invoice-profile.field.isDefault': '是否默认',
  'pages.zy-crm.invoice-profile.field.status': '状态',
  'pages.zy-crm.invoice-profile.field.remark': '备注',
  'pages.zy-crm.invoice-profile.field.createdAt': '创建时间',
  'pages.zy-crm.invoice-profile.option.boolean.yes': '是',
  'pages.zy-crm.invoice-profile.option.boolean.no': '否',
  'pages.zy-crm.contactOpportunity.field.status': '状态',
};
